import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allMachines } from 'app/mocks/data/machines/all'

import { formDataToData } from 'app/utils/app/requests'
import { api } from 'app/utils/constants'

import { SelfServiceTerminal } from 'app/types/machines/selfService'
import { TypeMachine } from 'app/types/shared/machine'

export const updateSelfService = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.machines.terminals.SELF_SERVICE}`,
    async ({ request, params }) => {
        const { id } = params

        const data = await request.formData()
        const payload = formDataToData(data)

        const dataParsed = SelfServiceTerminal.safeParse(payload)

        // Wrong data
        if (!dataParsed.success) {
            return HttpResponse.json(dataParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const fridgeWeightFound = allMachines.find(
            (machine) =>
                machine.id.toString() === id &&
                machine.category === TypeMachine.enum.FRIDGE_WEIGHT,
        )

        // Fridge weight not found
        if (!fridgeWeightFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<SelfServiceTerminal>(dataParsed.data)
    },
)
